import React, { FC, useEffect, useState } from "react"
import { KInput, KSpan, KTitleSpan, KDropdown, KButton, KLogo, KTooltip } from "kahuna-base-react-components"
import TrackIsrcCodes from "../track-isrc-codes/TrackIsrcCodes"
import ReleaseUpcCodes from "../release-upc-codes/ReleaseUpcCodes"
import State51BatchIds from "../state-51-batch-ids/State51BatchIds"
import { connect } from "react-redux"
import { RootState } from "../../../../store"

enum TabOptions {
  RELEASE_UPC = "Release Upc",
  TRACK_ISRC = "Track Isrc",
  STATE_51_BATCH_ID = "State 51 Batch Id"
}

type NewReleaseCodesProps = {
  userAdminPermissions?: string
}

const NewReleaseCodes: FC<NewReleaseCodesProps> = (props) => {
  const [openSidebar, setOpenSidebar] = useState<boolean>(true)
  const [selectedTab, setSelectedTab] = useState(TabOptions.RELEASE_UPC)

  return (
    <div className="catalog flex-grow justify-center">
      <div className="w-[100%] flex ">
        <div
          className={`${
            openSidebar ? "min-w-[230px]" : "min-w-0 !w-[0px]"
          } max-w-[320px] w-[20%] bg-[#F7F7F7] min-h-[100vh] flex flex-col overflow-hidden shrink-0`}
          style={{
            transitionDuration: "0.5s"
          }}
        >
          <div>
            <div className="py-1.5 px-4">
              <div className="p-2">
                <KTitleSpan text="New Release Codes" color="#111" fontSize={20} lineHeight="28px" />
              </div>
              <div
                data-testid="left-bar-upc"
                className={`rounded-[10px] p-2 flex flex-row gap-2 mt-4 items-center ${
                  selectedTab === TabOptions.RELEASE_UPC ? "bg-[#FFF]" : "transparent"
                } cursor-pointer whitespace-nowrap`}
                onClick={() => {
                  if (selectedTab === TabOptions.RELEASE_UPC) return
                  setSelectedTab(TabOptions.RELEASE_UPC)
                }}
              >
                <KSpan text={"Release UPC"} fontSize={12} lineHeight="20px" fontWeight={500} color="#111" />
              </div>
              <div
                data-testid="left-bar-isrc"
                className={`rounded-[10px] p-2 flex flex-row gap-1 mt-1 items-center ${
                  selectedTab === TabOptions.TRACK_ISRC ? "bg-[#FFF]" : "transparent"
                } cursor-pointer whitespace-nowrap`}
                onClick={() => {
                  if (selectedTab === TabOptions.TRACK_ISRC) return
                  setSelectedTab(TabOptions.TRACK_ISRC)
                }}
              >
                <KSpan text={"Track ISRC"} fontSize={12} lineHeight="20px" fontWeight={500} color="#111" />
              </div>
              <div
                data-testid="left-bar-state-51"
                className={`rounded-[10px] p-2 flex flex-row gap-1 mt-1 items-center ${
                  selectedTab === TabOptions.STATE_51_BATCH_ID ? "bg-[#FFF]" : "transparent"
                } cursor-pointer whitespace-nowrap`}
                onClick={() => {
                  if (selectedTab === TabOptions.STATE_51_BATCH_ID) return
                  setSelectedTab(TabOptions.STATE_51_BATCH_ID)
                }}
              >
                <KSpan text={"State 51 Batch Id"} fontSize={12} lineHeight="20px" fontWeight={500} color="#111" />
              </div>
            </div>
          </div>
        </div>
        <div className="grow min-h-0">
          {selectedTab === TabOptions.RELEASE_UPC && (
            <ReleaseUpcCodes userAdminPermissions={props.userAdminPermissions} />
          )}
          {selectedTab === TabOptions.TRACK_ISRC && (
            <TrackIsrcCodes userAdminPermissions={props.userAdminPermissions} />
          )}
          {selectedTab === TabOptions.STATE_51_BATCH_ID && (
            <State51BatchIds userAdminPermissions={props.userAdminPermissions} />
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    userAdminPermissions: state.auth.user.adminPermissions
  }
}

export default connect(mapStateToProps, {})(NewReleaseCodes)
